import angular from 'angular';

export default class DropzoneDirective {
	constructor() {
		this.restrict = 'A';
		this.scope = {
			addFiles: '&dropzone',
		};
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} scope
	 * @param {import('angular').IRootElementService} element
	 */
	link(scope, element) {
		scope.dragging = false;

		element.on('dragover', event => {
			element.addClass('dnd-drag-over');
			event.preventDefault();
			event.stopPropagation();
		});

		element.on('dragleave', event => {
			element.removeClass('dnd-drag-over');
			scope.dragging = false;
			event.preventDefault();
			event.stopPropagation();
		});

		element.on('dragenter', event => {
			scope.dragging = true;
			event.preventDefault();
			event.stopPropagation();
		});

		element.on('drop', event => {
			element.removeClass('dnd-drag-over');
			scope.dragging = false;
			event.stopPropagation();
			event.preventDefault();
			if (event.originalEvent?.dataTransfer?.files) {
				scope.addFiles({ $files: [...event.originalEvent.dataTransfer.files] });
			}
		});

		scope.$on('$destroy', () => {
			element.off('dragover dragleave dragenter drop');
		});
	}
}

const dropzoneDirective = () => new DropzoneDirective();

angular.module('app')
	.directive('dropzone', dropzoneDirective);
